import { useState, useEffect } from "react";
import { Badge } from "@/components/ui/badge";
import { supabase } from "@/components/atomic-crm/providers/supabase/supabase";

export function EmailTimeline({ contactId }: { contactId: number }) {
  const [emails, setEmails] = useState<any[]>([]);

  useEffect(() => {
    supabase
      .from("email_messages")
      .select(
        "*, team_member:sales!email_messages_sales_id_fkey(first_name, last_name)",
      )
      .eq("contact_id", contactId)
      .order("sent_at", { ascending: false })
      .limit(50)
      .then(({ data }) => {
        if (data) setEmails(data);
      });
  }, [contactId]);

  if (emails.length === 0) return null;

  return (
    <div>
      <h3 className="mb-3 text-sm font-semibold">
        Email History ({emails.length})
      </h3>
      <div className="space-y-2">
        {emails.map((e) => (
          <div key={e.id} className="rounded-md border p-3">
            <div className="mb-1 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Badge
                  variant="outline"
                  className={`text-[10px] ${
                    e.direction === "inbound"
                      ? "border-blue-300 text-blue-700"
                      : "border-green-300 text-green-700"
                  }`}
                >
                  {e.direction === "inbound"
                    ? "\u2190 Received"
                    : "\u2192 Sent"}
                </Badge>
                <span className="text-xs text-muted-foreground">
                  {e.team_member?.first_name} {e.team_member?.last_name}
                </span>
              </div>
              <span className="text-xs text-muted-foreground">
                {new Date(e.sent_at).toLocaleDateString()}{" "}
                {new Date(e.sent_at).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </span>
            </div>
            <p className="text-sm font-medium">{e.subject}</p>
            <p className="mt-1 line-clamp-2 text-xs text-muted-foreground">
              {e.body_preview}
            </p>
            {e.web_link && (
              <a
                href={e.web_link}
                target="_blank"
                rel="noopener"
                className="mt-1 inline-block text-xs text-primary hover:underline"
              >
                Open in Outlook &rarr;
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
